<template>
    <div class="editDialog">
        <el-dialog
            :title="datas.title"
            :visible.sync="dialogShow"
            :before-close="handleClose"
            width="840px"
            :close-on-click-modal="false"
        >
            <div class="content">
                <div class="group">
                    <span class="group-content">
                        <el-image
                            fit="cover"
                            v-for="(e, i) in datas.files"
                            :key="i"
                            :src="`/staticfile/${e.urlMinimal}`"
                            @click="onPreviewImg(datas.files.map(item => '/staticfile/' + item.src), i)"
                        ></el-image>
                        <span v-if="datas.files.length == 0">未上传</span>
                    </span>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleClose">确定</el-button>
            </div>
        </el-dialog>
        <el-image-viewer
            v-if="previewShow"
            :initialIndex="previewIndex"
            :on-close="closeViewer"
            :url-list="previewUrl"
            :z-index="3000"
        />
    </div>
</template>

<script>
import previewImg from '@/mixins/previewImg';
export default {
    mixins: [previewImg],
    props: {
        datas: {
            type: Object
        },
        dialogShow: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        };
    },
    methods: {
        handleClose() {
            this.$emit('update:dialogShow', false);
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    max-height: 600px;
    overflow: auto;
    .group {
        display: flex;
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
        .label {
            width: 80px;
            text-align: right;
            margin-right: 15px;
            color: #8797a7;
        }
        .group-content {
            flex: 1;
            .el-image {
                width: 180px;
                margin: 0 10px 10px;
                height: 150px;
            }
            span {
                color: #8797a7;
            }
        }
        .highLight {
            color: #007FF5;
            cursor: pointer;
        }
    }
}
</style>